<script>
import { Field, Uploader, Toast, Row, Col } from 'vant'
import DateTimeSelector from '@/components/org/DateTimeSelector'
import BottomToolbar from '@/components/org/BottomToolbar'
import DateTimeFunc from '@/tbs/util/DateTimeFunc'
import { QNImageUtil } from '@/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-match-signup-payment-edit',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-field': Field,
        'van-uploader': Uploader,
        'van-row': Row,
        'van-col': Col,
        'date-time-selector': DateTimeSelector,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            matchSignup: {
                id: null,
                matchId: null,
                name: null,
                description: null,
                imageUrls: [],
                startDateTime: null,
                endDateTime: null,
                frozenDateTime: null,
                teamTotal: null,
                skuId: null,
                config: {
                    teamSignupItems: [],
                    memberSignupItems: [],
                    teamNumLabel: null,
                    staffNumLabel: null,
                    matchGroupId: null,
                }
            },
            imageList: [],
            isEdit: null,
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
    },

    //--------------------------------------------------
    // component watch
    //--------------------------------------------------
    watch: {
        matchSignup(value) {
            console.log('watch match signup', value)
            if (value.imageList != null) {
                return
            }
            if (value.imageUrls) {
                const imageList = []
                for (let i = 0; i < value.imageUrls.length; i++) {
                    let item = value.imageUrls[i]
                    if (item) {
                        imageList.push({
                            url: this.adjustImageSize(item, 750, 750),
                            isImage: true,
                            value: item,
                        })
                    }
                }
                this.imageList = imageList
            }
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onOversizeTrigger() {
            console.log('onOversizeTrigger')
            Toast(this.locale['upload-image-oversize'])
        },
        onStartDateTimeDataChange(data) {
            console.log('onStartDateTimeDataChange', data)
            this.matchSignup.startDateTime = data
        },
        onEndDateTimeDataChange(data) {
            console.log('onEndDateTimeDataChange', data)
            // @tmp
            // try to trigger the validation for the submit button manually
            const name = this.matchSignup.name
            this.matchSignup.name += ' '
            this.matchSignup.name = name
            this.matchSignup.endDateTime = data
        },
        onFrozenDateTimeDataChange(data) {
            console.log('onFrozenDateTimeDataChange', data)
            this.matchSignup.frozenDateTime = data
        },
        onSubmitBtnClick() {
            console.log('onSubmitBtnClick')
            if (!this.validateSubmitRequired()) {
                // disable to submit and toast the message
                if (!this.matchSignup.name) {
                    Toast(this.locale['match-signup-name-required'])
                }
                else if (!this.matchSignup.endDateTime) {
                    Toast(this.locale['match-signup-end-time-required'])
                }
            }
            else {
                // enable to submit
                this.submitData()
            }
        },
        onSignupConfigBtnClick() {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgDetailMatchSignupConfig',
                    params: {
                        id: this.matchSignup.matchId
                    }
                }
            })
        },
        validateSubmitRequired() {
            // console.log('validateSubmitRequired')
            if (this.matchSignup.name 
                && this.matchSignup.endDateTime) {
                return true
            }
            else {
                return false
            }
        },
        submitData() {
            // console.log('submit data', this.matchSignup.imageList)
            const imageList = []
            for (let i = 0; i < this.imageList.length; i++) {
                let item = this.imageList[i]
                // console.log('item.file', item.file)
                imageList.push({
                    type: 'image',
                    file: item.file,
                    value: item.value
                })
            }
            // this.matchSignup.imageList = imageList
            // console.log('imageList', imageList)
            if (this.validateSubmitRequired()) {
                this.$emit('custom-event', {
                    type: 'save',
                    data: {
                        id: this.matchSignup.id,
                        matchId: this.matchSignup.matchId,
                        name: this.matchSignup.name,
                        description: this.matchSignup.description,
                        imageList: imageList,
                        startDateTime: this.matchSignup.startDateTime,
                        endDateTime: this.matchSignup.endDateTime,
                        frozenDateTime: this.matchSignup.frozenDateTime,
                        teamTotal: this.matchSignup.teamTotal,
                        matchGroupId: this.matchSignup.config.matchGroupId,
                        skuId: this.matchSignup.skuId,
                    }
                })
            }
        },
        getCalendarValue(dateTime) {
            return dateTime
        },
        getTimeValue(dateTime) {
            if (dateTime) {
                return DateTimeFunc.formatDate(dateTime, 'hh:mm')
            }
            return null
        },
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
    },
}
</script>

<template>
    <div class="match-signup-payment-edit">
        <div class="main-fields">
            <van-field 
                v-model="matchSignup.name" 
                :placeholder="locale['match-signup-name-placeholder']"
                clearable
                maxlength="20" 
            />
            <van-field 
                v-model="matchSignup.description" 
                :placeholder="locale['match-signup-desc-placeholder']"
                clearable
                type="textarea"
                rows="4"
                autosize
                maxlength="200"
                show-word-limit
            />
            <div class="bg-white u-outer-padding">
                <van-uploader
                    v-model="imageList"
                    multiple
                    :preview-size="105"
                    :max-count="5"
                    :max-size="5000*1024"
                    :upload-text="locale['upload-nice-photo']"
                    @oversize="onOversizeTrigger"
                />
            </div>    
        </div>
        <div class="minor-fields t-outer-margin">
            <date-time-selector
                :label="locale['match-signup-start-time']"
                :datePlaceholder="locale.date"
                :timePlaceholder="locale.time"
                :clearable="true"
                :calendarValue="getCalendarValue(matchSignup.startDateTime)"
                :timeValue="getTimeValue(matchSignup.startDateTime)"
                @change-data="onStartDateTimeDataChange"
            />
            <date-time-selector
                :label="locale['match-signup-end-time']"
                :datePlaceholder="locale.date"
                :timePlaceholder="locale.time"
                :clearable="true"
                :calendarValue="getCalendarValue(matchSignup.endDateTime)"
                :timeValue="getTimeValue(matchSignup.endDateTime)"
                @change-data="onEndDateTimeDataChange"
            />
            <date-time-selector
                :label="locale['match-signup-frozen-time']"
                :datePlaceholder="locale.date"
                :timePlaceholder="locale.time"
                :clearable="true"
                :calendarValue="getCalendarValue(matchSignup.frozenDateTime)"
                :timeValue="getTimeValue(matchSignup.frozenDateTime)"
                @change-data="onFrozenDateTimeDataChange"
            />
            <van-field
                v-model="matchSignup.teamTotal"
                :label="locale['match-signup-team-total']"
                type="digit"
                clearable
                input-align="right"
                maxlength="4"
            />
            <van-cell
                :title="locale['signup-data']"
                :value="locale['config']"
                is-link center
                @click="onSignupConfigBtnClick"
            />
            <div v-if="matchSignup.config"  class="signup-config bg-white u-outer-padding">
                <van-row class="item">
                    <van-col span="6" class="property inline-block">
                        <span class="minor-text minor-color">{{ locale['team-signup-data'] }}</span>
                    </van-col>
                    <van-col span="18" class="value inline-block">
                        <div class="wrapper">
                            <div class="text-right">
                                <div 
                                    v-for="item in matchSignup.config.teamSignupItems" 
                                    :key="item.value"
                                    class="inline-block r-outer-margin"
                                >
                                    <div class="bg-primary corner-round-sm b-narrow-margin">
                                        <div class="u-narrow-padding">
                                            <span class="minor-text color-white">{{ item.label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </van-col>
                </van-row>
                <van-row class="item t-outer-margin">
                    <van-col span="6" class="property inline-block">
                        <span class="minor-text minor-color">{{ locale['member-signup-data'] }}</span>
                    </van-col>
                    <van-col span="18" class="value inline-block">
                        <div class="wrapper">
                            <div class="text-right">
                                <div 
                                    v-for="item in matchSignup.config.memberSignupItems" 
                                    :key="item.value"
                                    class="inline-block r-outer-margin"
                                >
                                    <div class="bg-primary corner-round-sm b-narrow-margin">
                                        <div class="u-narrow-padding">
                                        <span class="minor-text color-white">{{ item.label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </van-col>
                </van-row>
                <van-row v-if="matchSignup.config.teamNumLabel" class="item t-outer-margin">
                    <van-col span="6"  class="property inline-block">
                        <span class="minor-text minor-color">{{ locale['team-number'] }}</span>
                    </van-col>
                    <van-col span="18"  class="value inline-block text-right">
                        <span class="minor-text">{{ matchSignup.config.teamNumLabel }}</span>
                    </van-col>
                </van-row>
                <van-row v-if="matchSignup.config.staffNumLabel" class="item t-outer-margin b-outer-margin">
                    <van-col span="6" class="property inline-block">
                        <span class="minor-text minor-color">{{ locale['staff-number'] }}</span>
                    </van-col>
                    <van-col span="18"  class="value inline-block text-right">
                        <span class="minor-text">{{ matchSignup.config.staffNumLabel }}</span>
                    </van-col>
                </van-row>
            </div>
        </div>
        <bottom-toolbar 
            type="button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            @click-main-button="onSubmitBtnClick"
        />
    </div>
</template>

<style scoped>
.signup-config {
    padding-left: 32px;
}
</style>